import React, { useState, useEffect } from 'react';
import { REACT_APP_PUBLIC_URL } from '@/constants/Constants';
import useMonitorRule from '../hooks/use-monitor-rule';
import { hasFeatureFlagSuper, hasPurview } from '@/services';
import { getNoticeCount } from '../api';
import { ObjectType } from '../model';
import { reportUserBehavior } from '@/pages/agency/utils/util';

import './assets/index.scoped.less';

interface MonitorNotice {
  rule_type: string;
  cnt: number;
}

interface MonitorNoticeProps {
  // 账户维度
  onAccountNotice?: () => void;
}

const MonitorNotice = (props: MonitorNoticeProps) => {
  const { onAccountNotice } = props;
  const [noticeList, setNoticeList] = useState<Array<MonitorNotice>>([]);

  const { ruleMap } = useMonitorRule();

  useEffect(() => {
    getNoticeList();
  }, []);

  const getNoticeList = async () => {
    const res: any = await getNoticeCount();
    setNoticeList(res?.data || []);
  };

  const handleClick = (rule_type: string) => {
    reportUserBehavior({
      behaviorType: '查看监控提醒',
    });
    const { group = [] } = ruleMap[rule_type] || {};
    const type = group.includes(ObjectType.advertiser) ? 'account' : 'ad';
    window.open(`${REACT_APP_PUBLIC_URL}/agency/monitor/list/${type}?params={"rule_types":["${rule_type}"]}`);
    // if (group.includes(ObjectType.advertiser)) { // 账户维度
    //   if (onAccountNotice) { // 页面内刷新
    //     onAccountNotice?.();
    //   } else { // 直接跳转
    //     window.open(`${REACT_APP_PUBLIC_URL}/agency/advertiser-group`);
    //   }
    // } else { // 广告维度
    //   window.open(`${REACT_APP_PUBLIC_URL}/agency/monitor/list/${type}`);
    // }
  };

  return hasPurview(210) && noticeList.length ? <div className="monitor-notice-list">
    {noticeList.map((v) => {
      const { rule_type, cnt } = v;
      return <div
        className="monitor-notice-item"
        key={rule_type}
        onClick={() => handleClick(rule_type)}
        data-report="monitor-notice-rule-type"
        data-report-extra={`relation_key:rule_type;relation_value:${rule_type}`}
      >
        <i className="icon-notice" />
        <span className="name" >{ruleMap[rule_type]?.title || rule_type}<span className="red">{cnt}</span>条</span>
      </div>;
    })}
  </div> : null;
};

export default MonitorNotice;
